import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Container = styled.div`
  height: 44px;
  display: flex;
  align-items: center;
  cursor: pointer;
  background-color: ${props => props.highlight? '#F75C2F' : ''};
  color: ${props => props.highlight? '#FFF': '#a7a7a7'};
  padding-right: 16px;
  i {
    font-size: 28px;
    text-align: center;
    margin: 0 18px 0 16px;
  }
`;
const Title = styled.div`
  font-size: 18px;
  font-weight: bold;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
class BannerItem extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    currentIndex: PropTypes.number.isRequired,
    index: PropTypes.number.isRequired,
    goToNextSlide: PropTypes.func.isRequired,
  };

  handleClick = () => {
    const index = this.props.index;
    this.props.goToNextSlide(index);
  }

  render() {
    const { index, currentIndex } = this.props;
    return(
      <Container highlight={index===currentIndex} onClick={this.handleClick} >
        <i className="zmdi zmdi-chevron-left"></i>
        <Title>{this.props.title}</Title>
      </Container>
    )
  }
}

export default BannerItem;